<template>
  <div :style="{ 'display': isWideScreen ? 'flex' : 'block' }">
    <el-card
      class="box-card"
      :style="{'width': isWideScreen ? '50%' : '96%',  'margin': isWideScreen ? '10px' : '2%'}"
      v-for="item in list"
      :key="item.name"
    >
      <div slot="header" class="clearfix">
        <span class="title">
          {{ item.name }}
        </span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text"
          >操作按钮</el-button
        > -->
      </div>
      <div>
        <span>
          <h3 class="subtitle">
            {{ item.subTitle }}
          </h3>
          <p>{{ item.content }}</p>
        </span>
      </div>
    </el-card>
  </div>
</template>


<script>
import { Card } from "element-ui";

export default {
  name: "ProductIntro",
  components: {
    ElCard: Card,
  },
  props: {
    isWideScreen: Boolean,
  },

  data() {
    return {
      
    };
  },
  computed:
  {
    list() {
      return this.$t("productIntro.list")
    }
  },
  mounted() {
    
  },
  methods: {},
};
</script>

<style scoped>
.box-card
{
  text-align: left;
  margin: 0;
  
}
.clearfix {
  text-align: left;
  align-content: left;
  align-items: left;
  margin:auto;
}
.title {
  text-align: left;
  
} 
.subtitle {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductIntro.vue